import React, { Component } from 'react';

import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';

import './styles.less';

class PublishChangesButton extends Component {
  static className = 'trim-bar-publish-changes-button';

  render() {
    const { currentTrimRange, newTrimChanges, showActionDot } = this.props;

    const canPublishTrim = currentTrimRange == null && newTrimChanges;
    const publishTrimClass = canPublishTrim ? 'enabled' : '';

    const publishChangesOnClick = canPublishTrim
      ? this.props.onPublishChanges
      : null;

    return (
      <div
        className={`trim-bar-button ${this.constructor.className} ${publishTrimClass}`}
        onClick={publishChangesOnClick}
      >
        {showActionDot && <ActionDot position={TOP_LEFT} />}
        <span className="icon" />
        <span className="label">Publish Changes</span>
      </div>
    );
  }
}

export default PublishChangesButton;
